import { useContext, useState } from 'react'
import styles from "../../../../Styles/ComponentStyles/ProfileStyle/ProfileRothConversion/QuickRothConversionDialog.module.scss"
import globalStyles from '../../../../Styles/ComponentStyles/global.module.scss';

import { Close } from '@mui/icons-material'
import { Grid, IconButton, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material'
import GlobalButton from '../../../../Utils/GlobalUtilsComponents/GlobalButton'
import { ProfileContext, ProfileContextPayload } from '../../../../Context/ProfileDetailsContext'
import { useSnackbar } from '../../../../GlobalComponent/GlobalSnackbar/GlobalSnackbar';
import { UserContext, UserContextPayload } from '../../../../Context/UserDetailContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import _cloneDeep from 'lodash/cloneDeep';
import IconsColor from '../../../../Utils/IconsColor';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import GlobalTextfield from '../../../../GlobalComponent/GlobalTextfield/GlobalTextfield';

const rothConversionFieldValidators: Record<string, (value: any) => boolean> = {
    rothConversionIssueAge: (value) => value >= 21 && value <= 80,
    rothConversionAgeLifetimeBegin: (value) => value >= 60 && value <= 99,
    rothConversionPremium: () => true,
    rothConversionPremiumBonus: () => true,
    rothConversionAnnualPreWithdrawalRate: () => true,
    rothConversionAnnualPostWithdrawalRate: () => true,
    rothConversionPeriod: (value) => Number(value) >= 1 && Number(value) <= 10,
    rothConversionSingleIra: (value) => Number(value) >= 12.00 && Number(value) <= 37.00,
    rothConversionPartialIra: (value) => Number(value) >= 12.00 && Number(value) <= 37.00,
    rothConversionReceivingIra: (value) => Number(value) >= 12.00 && Number(value) <= 37.00,
    rothConversionPortfolioWithdrawalRate: (value) => Boolean(String(value)?.trim()),
    rothConversionWithholding: () => true,
    rothConversionLifeExpectancyAge: () => true,
};

const rothConversionValidationRules: Array<{
    key: string;
    requiredMessage: string;
    range?: { min: number; max: number; message: string };
}> = [
    { key: 'rothConversionIssueAge', requiredMessage: 'Issue age is required', range: { min: 21, max: 80, message: 'Enter age between 21 and 80' } },
    { key: 'rothConversionAgeLifetimeBegin', requiredMessage: 'Age is required', range: { min: 60, max: 99, message: 'Enter age between 60 and 99' } },
    { key: 'rothConversionPremium', requiredMessage: 'Premium is required' },
    { key: 'rothConversionAnnualPreWithdrawalRate', requiredMessage: 'Estimated annual interest pre withdrawals is required' },
    { key: 'rothConversionAnnualPostWithdrawalRate', requiredMessage: 'Estimated annual interest post withdrawals is required' },
    { key: 'rothConversionPeriod', requiredMessage: 'Conversion period is required' },
    { key: 'rothConversionSingleIra', requiredMessage: 'Tax rate is required', range: { min: 12.00, max: 37.00, message: 'Enter value between 12.00% and 37.00%' } },
    { key: 'rothConversionPartialIra', requiredMessage: 'Tax rate is required', range: { min: 12.00, max: 37.00, message: 'Enter value between 12.00% and 37.00%' } },
    { key: 'rothConversionReceivingIra', requiredMessage: 'Tax rate is required', range: { min: 12.00, max: 37.00, message: 'Enter value between 12.00% and 37.00%' } },
    { key: 'rothConversionPortfolioWithdrawalRate', requiredMessage: 'Portfolio withdrawal rate is required' },
    { key: 'rothConversionLifeExpectancyAge', requiredMessage: 'Life expectancy age is required' },
    { key: 'rothConversionWithholding', requiredMessage: 'This field is required' },
];

function QuickRothConversionDioalog(props: any) {

    const {
        setFlagOpenQuickEditDialog,
        profileUserDetails,
        setProfileUserDetails,
        setProfileName,
        updateUserProfileAPI,
        getparticularUserProfileDetail,
        setProfileRothConversionDetails
    } = useContext(ProfileContext) as ProfileContextPayload

    const { setFlagLoader, } = useContext(UserContext) as UserContextPayload

    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('user_id');

    const [formErrors, setFormErrors] = useState<any>({});

    const handleInputChange = (section: any, field: string, value: any) => {
        const arr = ["rothConversionPremium"]
        const checkPercentagearr = ["rothConversionAnnualPreWithdrawalRate", "rothConversionAnnualPostWithdrawalRate", "rothConversionPeriod", "rothConversionSingleIra", "rothConversionPartialIra", "rothConversionReceivingIra", "rothConversionPremiumBonus"]
        if (arr.includes(field)) {
            value = value.replace(/,/g, "");
            if (!isNaN(value) && value.trim() !== "") {
                value = Number(value).toLocaleString();
            }
        }
        if (checkPercentagearr.includes(field)) {
            if (Number(value) < 0 || Number(value) > 100) {
                return;
            }
        }

        setProfileUserDetails((prev: any) => {
            const updated = { ...prev };
            if (!updated.inputData || !updated.inputData[0]) return prev;

            updated.inputData[0] = {
                ...updated.inputData[0],
                rothConversionData: {
                    ...updated.inputData[0].rothConversionData,
                    [field]: value,
                },
            };

            return updated;
        });


        setFormErrors((prevErrors: any) => {
            const updatedErrors = { ...prevErrors };
            if (section === "rothConversionData" && rothConversionFieldValidators[field]?.(value)) {
                delete updatedErrors?.rothConversionData?.[field];
            }
            return updatedErrors;
        });

    }

    const validateProfileForm = (profileUserDetails: any): { isValid: boolean; errors: any } => {
        const errors: any = {};
        let isValid = true;

        const input = profileUserDetails?.inputData?.[0];
        if (!input) return { isValid: false, errors };

        const roth = input.rothConversionData || {};
        errors.rothConversionData = {};

        rothConversionValidationRules.forEach(({ key, requiredMessage, range }) => {
            const value = roth[key];
            if (!value) {
                errors.rothConversionData[key] = requiredMessage;
                isValid = false;
            } else if (range && (value < range.min || value > range.max)) {
                errors.rothConversionData[key] = range.message;
                isValid = false;
            }
        });

        return { isValid, errors };
    };

    const handleProfileFormSubmit = async () => {
        const { isValid, errors } = validateProfileForm(profileUserDetails);

        if (!isValid) {
            setFormErrors(errors);
            showSnackbar("Please fill in all required fields correctly", "error");
            return;
        }

        const input = profileUserDetails.inputData?.[0];
        const roth = input.rothConversionData;
        try {
            let apiPayload: any = {
                user_profile_type_id: 2,

                user_name: input?.universalInput?.firstName,
                user_current_age: input?.universalInput?.currentAge,
                user_retirement_age: input?.universalInput?.ageAtRetirement,
                user_contact: input?.universalInput?.Contact,
                user_email: input?.universalInput?.email,

                user_roth_conversion_issue_age: roth.rothConversionIssueAge,
                user_roth_conversion_age_lifetime_begin: roth.rothConversionAgeLifetimeBegin,
                user_roth_conversion_premium: roth.rothConversionPremium,
                user_roth_conversion_pre_withdrawal_rate: roth.rothConversionAnnualPreWithdrawalRate,
                user_roth_conversion_post_withdrawal_rate: roth.rothConversionAnnualPostWithdrawalRate,
                user_roth_conversion_period: roth.rothConversionPeriod,
                user_roth_conversion_life_expectancy_age: roth.rothConversionLifeExpectancyAge,
                user_roth_conversion_single_ira: roth.rothConversionSingleIra,
                user_roth_conversion_partial_ira: roth.rothConversionPartialIra,
                user_roth_conversion_receiving_ira: roth.rothConversionReceivingIra,
                user_roth_conversion_withdrawal_rate: roth.rothConversionPortfolioWithdrawalRate,
                user_roth_conversion_tax_withholding: roth.rothConversionWithholding,
                user_roth_conversion_premium_bonus: roth.rothConversionPremiumBonus,

                user_tpi_contribution_data: input?.typicalPlan?.user_tpi_contribution_data?.map((item: any) => ({
                    total_contribution: item?.annualContribution,
                    duration: item?.duration
                })),

                user_iul_assigned_agent_id: input?.AssignProfile?.agentId ? [input?.AssignProfile?.agentId] : [],

                sample_profile_flag: false
            };

            apiPayload['user_profile_id'] = userId;

            setFlagLoader(true);
            const response = await updateUserProfileAPI(apiPayload)
            if (response?.status) {
                const currentTab = searchParams.get("tab") || "1";
                navigate(`/profile/annuityProfileDetails/annuityRoth?user_id=${userId}&tab=${currentTab}`);
                showSnackbar(`Profile Updated Successfully!`, "success");
                // setFlagLoader(false);
                setFlagOpenQuickEditDialog(false)

                const response = await getparticularUserProfileDetail(userId);
                if (response?.status) {
                    if (response?.data && response?.inputData) {
                        setProfileName(response?.inputData?.[0]?.universalInput?.firstName);
                        setProfileUserDetails({
                            data: _cloneDeep(response.data),
                            inputData: _cloneDeep(response.inputData),
                        });
                        setProfileRothConversionDetails({ data: response.data, inputData: response.inputData });
                    }
                    setFlagLoader(false);
                }
                else {
                    showSnackbar(response?.error?.message || "Something went wrong!", "error");
                    setFlagLoader(false);
                }
            }
            else {
                setFlagLoader(false);
                showSnackbar(response?.error?.message || "Error creating profile", "error");
                setFlagOpenQuickEditDialog(false)
            }
        }
        catch (error) {
            setFlagLoader(false);
            setFlagOpenQuickEditDialog(false)
            console.log(error, "Error submitting data!");
        }
    };

    return (
        <>
            <Grid container sx={{ height: "100%" }}>
                <Grid item xs={12} sx={{ height: "100%" }}>
                    <Grid container sx={{ height: "100%" }}>
                        <Grid item xs={12}>
                            <Grid container sx={{ alignItems: "center" }}>
                                <Grid item xs={11} sx={{ position: "relative" }}>
                                    <Grid container>
                                        <IconButton sx={{ padding: '2px', marginLeft: "-10px" }}>
                                            <DragIndicatorIcon sx={{ color: "#0F172B", fontSize: "25px" }} />
                                        </IconButton>
                                        <Typography component={'span'} className={styles.rothConHeadText}>
                                            Quick Edit
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: 'end' }}>
                                    <IconButton sx={{ padding: '2px' }} onClick={() => { setFlagOpenQuickEditDialog(false) }}>
                                        <Close sx={{ color: '#0F172B', }} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.rothQEFieldMainItem}>
                            <Grid container sx={{ justifyContent: 'start', gap: "20px" }}>
                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Issue Age <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Issue Age'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionIssueAge}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionIssueAge', e.target.value)}

                                            />
                                            <label className={formErrors.rothConversionData?.rothConversionIssueAge ? globalStyles.helperTextStyle : styles.helperTextStyle}>{"Enter age between 21 and 80"}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Withdrawal Start Age <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Withdrawal Start Age'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionAgeLifetimeBegin}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionAgeLifetimeBegin', e.target.value)}
                                            />
                                            <label className={formErrors.rothConversionData?.rothConversionAgeLifetimeBegin ? globalStyles.helperTextStyle : styles.helperTextStyle}>{"Enter an age between 60 and 99"}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Premium ($) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Premium'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    if (!/[0-9]$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionPremium}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionPremium', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="dollarIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <label className={globalStyles.helperTextStyle}>{formErrors?.rothConversionData?.rothConversionPremium}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Premium Bonus (%)  <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Premium Bonus'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionPremiumBonus}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionPremiumBonus', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Pre-withdrawals interest (%) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Pre-withdrawals interest'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionAnnualPreWithdrawalRate}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionAnnualPreWithdrawalRate', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Post-withdrawals interest (%) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Post-withdrawals interest'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionAnnualPostWithdrawalRate}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionAnnualPostWithdrawalRate', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Conversion period (years) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Conversion period'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    if (!/[0-9]$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionPeriod}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionPeriod', e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Life expectancy (age) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Life expectancy'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    if (!/[0-9]$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionLifeExpectancyAge}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionLifeExpectancyAge', e.target.value)}
                                            />
                                            <label className={globalStyles.helperTextStyle}>{formErrors?.rothConversionData?.rothConversionLifeExpectancyAge}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Tax rate (single Roth IRA) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Tax rate (single Roth IRA)'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionSingleIra}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionSingleIra', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <label className={formErrors.rothConversionData?.rothConversionSingleIra ? globalStyles.helperTextStyle : styles.helperTextStyle}>{"Enter value between 12.00% and 37.00%"}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Tax rate (partial Roth IRA) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Tax rate (partial Roth IRA)'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionPartialIra}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionPartialIra', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <label className={formErrors.rothConversionData?.rothConversionPartialIra ? globalStyles.helperTextStyle : styles.helperTextStyle}>{"Enter value between 12.00% and 37.00%"}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Tax rate (lifetime withdrawals) <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Tax rate (lifetime withdrawals)'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionReceivingIra}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionReceivingIra', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <label className={formErrors.rothConversionData?.rothConversionReceivingIra ? globalStyles.helperTextStyle : styles.helperTextStyle}>{"Enter value between 12.00% and 37.00%"}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Income tax withholding <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Select
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                className={styles.rothQEDropdown}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionWithholding}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionWithholding', e.target.value)}
                                            >
                                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                                <MenuItem value={"No"}>No</MenuItem>
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.rothQEFieldItem}>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.rothFieldLabelItem}>
                                            <Typography component={'span'} className={globalStyles.globalPFTextfieldLabel}>
                                                Annual withdrawal rate <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <GlobalTextfield
                                                variant="outlined"
                                                placeholder='Enter Annual withdrawal rate'
                                                stylingClassName={globalStyles.globalPFTextfield}
                                                fullWidth
                                                size='small'
                                                autoComplete='off'
                                                onKeyPress={(e: any) => {
                                                    const value = e.target.value;
                                                    if (!/^[0-9.]$/.test(e.key) || (e.key === '.' && value.includes('.'))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={profileUserDetails?.inputData[0]?.rothConversionData?.rothConversionPortfolioWithdrawalRate}
                                                onChange={(e) => handleInputChange('rothConversionData', 'rothConversionPortfolioWithdrawalRate', e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <label className={globalStyles.helperTextStyle}>{formErrors?.rothConversionData?.rothConversionPortfolioWithdrawalRate}</label>
                                        </Grid>
                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <GlobalButton
                                value="Save"
                                size='medium'
                                variant='contained'
                                className={styles.rothFieldSaveBtn}
                                onClick={() => handleProfileFormSubmit()}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default QuickRothConversionDioalog